<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" title="在线申诉" width="620px" @close="$emit('update:visible', dialogVisible)">
      <el-radio-group v-model="auditType">
        <el-radio label="success">已自行{{ fRiskSourceText }}申诉，且申诉成功。<span v-if="lastTimeAudit && lastTimeAudit==='wechat'" class="red">（上次申诉）</span></el-radio>
        <p class="tips">违规类型为微信违规、或支付宝违规的商户，可自行到微信平台、支付宝平台进行申诉，并将申诉成功凭证以图片形式在此提交即可解冻乐刷商户权限。</p>

        <div>
          <uploadImg
            label="上传凭证"
            :required="true"
            placeholder="上传凭证"
            valueName="appealEvidence"
            v-model="appealEvidence"
            :value="appealEvidence"
            @success="uploadSuccess"></uploadImg>
        </div>
        <div class="ml10">
          <upload-files valueName="makeUpData" :limit="1" @success="uploadFileSuccess"></upload-files>
        </div>

        <el-radio label="failed">已自行{{ fRiskSourceText }}申诉，但申诉失败，或放弃{{ fRiskSourceText }}申诉。<span v-if="lastTimeAudit && lastTimeAudit==='failed'" class="red">（上次申诉）</span></el-radio>
        <p class="tips">（仅申请解冻乐刷商户权限）</p>
        <!--                <el-radio label="notYet" :disabled="true">未进行{{fRiskSourceText}}申诉，需乐刷协助申诉。<span v-if="lastTimeAudit && lastTimeAudit==='notYet'"></span>（上次申诉）</el-radio>-->
        <!--                <p class="tips">(若{{fRiskSourceText}}申诉通过，将同时解冻乐刷商户权限）</p>-->
      </el-radio-group>
      <div class="btmBtn">
        <el-button type="primary" @click="onLineAppealSubmit" :loading="loading">确定</el-button>
        <el-button @click="dialogVisible = false;$emit('close-online', dialogVisible)">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import uploadImg from '@/components/upload/uploadImg'
import uploadFiles from '@/components/upload/uploadFiles'
import { manualAppealCommit } from '@/api/risk'
export default {
  name: 'OnlineWechatAlipay',
  components: {
    uploadImg,
    uploadFiles
  },
  props: {
    // 当前操作的对象
    row: {
      type: Object,
      default () {
        return {}
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false, // 微信、支付宝风控在线申诉弹窗
      // 是否是首次申诉，若是首次就选择申诉方式，否则就是修改申诉方式
      auditType: 'success', // 申诉方式
      lastTimeAudit: '', // 上次申诉方式
      loading: false, // 提交按钮加载
      appealEvidence: '', // 人工申诉凭证
      successfulAppealMaterials: '' // 补充资料
    }
  },
  watch: {
    visible (value) {
      this.dialogVisible = value
    }
  },
  computed: {
    // 申诉类型，微信或支付宝，fAppealInfoType等于3是支付宝，2是微信，4是微信/支付宝不通过,乐刷解冻
    fRiskSourceText () {
      return this.row.fRiskSource === 3 ? '支付宝' : '微信'
    }
  },
  mounted () {
    // 如果申诉不通过，判断上次选择项
    this.dialogVisible = this.visible
    if (this.row.auditStatus === 3) {
      // 如果该字段有内容说明是上次是选择申诉成功，上次凭证，回填图片，否则说明是选申诉失败，乐刷解冻
      if (this.row.fManualAppealEvidence.replace(/\s/g, '') !== '') {
        // eslint-disable-next-line no-useless-escape
        const url = this.row.fManualAppealEvidence.replace(/[\[\]"]/g, '')
        this.appealEvidence = url
        this.lastTimeAudit = 'wechat'
        this.auditType = 'success'
      } else {
        this.appealEvidence = ''
        this.auditType = 'failed'
        this.lastTimeAudit = 'failed'
      }
    } else {
      this.lastTimeAudit = ''
    }
  },
  methods: {
    /**
             * 微信、支付宝在线申诉确认
             */
    onLineAppealSubmit () {
      // 如果选择已自行申诉但申诉失败，仅乐刷解冻
      if (this.auditType === 'failed') {
        const otherAppealForm = {
          ticketNumber: this.row.fTicketNumber,
          merchantId: this.row.fMerchantId,
          appealInfoType: 4, // this.row.fAppealInfoType
          riskSource: this.row.fRiskSource,
          fManualAppealResult: this.row.fManualAppealResult
        }
        const data = {
          otherAppealForm: otherAppealForm,
          type: 'failed'
        }
        this.$emit('update:visible', false)
        this.$emit('success', data)
      } else {
        if (this.auditType === 'success' && this.appealEvidence === '') {
          this.$message({
            message: '请先上传凭证',
            type: 'error'
          })
          return false
        }
        this.loading = true
        const that = this
        let optType = ''
        if (this.row.fRiskSource === 2) {
          optType = 1
        }
        if (this.row.fRiskSource === 3) {
          optType = 2
        }
        // this.successfulAppealMaterials = this.successfulAppealMaterials.map(item => {
        //   return {
        //     name: item.name,
        //     path: item.path,
        //     showPath: item.showPath
        //   }
        // })
        let data = {
          ticketNumber: this.row.fTicketNumber,
          merchantId: this.row.fMerchantId,
          riskSource: this.row.fRiskSource,
          optType: optType,
          appealEvidence: this.appealEvidence,
          yeahkaAssistance: 2,
          successfulAppealMaterials: this.successfulAppealMaterials
        }
        data = qs.stringify(data)
        manualAppealCommit(data).then((data) => {
          that.loading = false
          if (parseInt(data.error_code) !== 0) {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
          } else {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'success'
            })
            const result = {
              type: 'success'
            }
            this.$emit('update:visible', false)
            this.$emit('success', result)
          }
        }).catch(() => {
          that.loading = false
        })
      }
    },
    /**
             * @description 上传图片成功
             * @param  {object} data 上传成功接口返回数据及该数据对应属性名
             */
    uploadSuccess (data) {
      this[data.valueName] = data.path
    },
    /**
             * @description 补充资料上传成功的回调
             */
    uploadFileSuccess (data) {
      this.successfulAppealMaterials = data.path
    }
  }
}
</script>

<style scoped>
    .red{
        color: #ff7070;
    }
    .tips{
        font-size: 14px;
        line-height: 20px;
        color: #999;
    }
    .marginBtm{
        margin-bottom: 30px;
    }
    .ml10 {
        margin-left:-10px;
    }
</style>
